import { createSelector } from 'reselect';
import { surveySliceName } from './utils';
export var baseSurveySelector = function (state) { return state[surveySliceName]; };
export var defaultSurveySelector = createSelector(baseSurveySelector, function (_a) {
    var defaultSurvey = _a.defaultSurvey;
    return defaultSurvey;
});
export var surveySelector = createSelector([baseSurveySelector, function (_, idOrAlias) { return idOrAlias; }], function (_a, idOrAlias) {
    var _b;
    var aliases = _a.aliases, items = _a.items;
    var surveyId = (_b = aliases[idOrAlias]) !== null && _b !== void 0 ? _b : idOrAlias;
    return items[surveyId];
});
